export interface IGenericDialogProps {
    title: string;
}

export interface IMessageDialogProps {
    title: string;
    description?: string;
    type: IMessageDialogTypes;
    closeButtonIcon?: JSX.Element | null;
    closeButtonText?: string | null;
    closeFn: () => void;
}

export const toastMessages = {
    error: parseFloat(process.env.REACT_APP_TOAST_SUCCESS_ERROR_TTL || '3000'),
    success: parseFloat(process.env.REACT_APP_TOAST_SUCCESS_SUCCESS_TTL || '1500'),
};

export type IMessageDialogTypes = 'alert' | 'error' | 'generic' | 'info' | 'loading' | 'warning';
